/** Prefill ShopLight newsletter SSR forms from widget auth. HTML is cached — never SSR PII. */

export type NewsletterAuth = {
  login?: string;
  name?: string;
  customer_uid?: string;
  customer_email?: string;
  email?: string;
} | null;

export function newsletterPrefillFromAuth(auth: NewsletterAuth): {
  email: string;
  name: string;
  lockEmail: boolean;
} {
  if (!auth) {
    return { email: '', name: '', lockEmail: false };
  }
  const email = String(auth.customer_email ?? auth.email ?? '').trim();
  const name = String(auth.name ?? '').trim() || String(auth.login ?? '').trim();
  const loggedIn = !!(auth.login || auth.customer_uid || email);
  return {
    email,
    name,
    lockEmail: loggedIn && email !== '',
  };
}

export function syncNewsletterFormPrefill(auth: NewsletterAuth): void {
  if (typeof document === 'undefined') return;
  const fill = newsletterPrefillFromAuth(auth);
  document.querySelectorAll('form[data-sl-newsletter-form]').forEach((form) => {
    const emailEl = form.querySelector<HTMLInputElement>('input[name="email"]');
    const nameEl = form.querySelector<HTMLInputElement>('input[name="subscribe_name"]');
    if (!emailEl && !nameEl) return;
    if (!fill.lockEmail && fill.email === '' && fill.name === '') {
      if (emailEl?.dataset.slAuthed === '1') {
        emailEl.value = '';
        emailEl.readOnly = false;
        delete emailEl.dataset.slAuthed;
      }
      if (nameEl?.dataset.slAuthed === '1') {
        nameEl.value = '';
        delete nameEl.dataset.slAuthed;
      }
      return;
    }
    if (emailEl && fill.email) {
      emailEl.value = fill.email;
      emailEl.readOnly = fill.lockEmail;
      emailEl.dataset.slAuthed = '1';
    }
    if (nameEl && fill.name) {
      nameEl.value = fill.name;
      nameEl.dataset.slAuthed = '1';
    }
  });
}
